import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    data: {},
    loading: false,
    dataType: {},
    currentErrorCode: null,
});

const reducers = (state = initialState(), { type, payload }) => {
    switch (type) {
        case globalTypes.INITIALIZE:
        case types.CLEAR_ORDER:
            return initialState();

        case types.SET_ORDER_DATA:
            return { ...state, data: { ...(payload || {}) } };

        case types.SET_LOADING:
            return reduceAction(state, 'loading', payload);

        case types.SET_CURRENT_ERROR_CODE:
            return reduceAction(state, 'currentErrorCode', payload || null);

        case types.RESET_ERROR_CODE:
            return reduceAction(state, 'currentErrorCode', null);

        case types.SET_DATA_TYPE:
            return { ...state, dataType: { ...payload } };

        case types.SET_EGIFT_CARD_ENTRY_NUMBER:
            return reduceAction(state, 'eGiftEntryNumber', payload.entryNumber);

        case types.SET_EGIFT_CARD_RESEND_ATTEMPTS:
            return reduceAction(state, 'isEGiftResendAttemptsExpired', payload);

        default:
            return state;
    }
};

export default reducers;
